import { useState } from 'react'
import { useSession } from 'src/providers/auth.provider'
import { ResourceChangeHistoryModal } from './resource-change-history-modal.component'
import { useTranslation } from 'react-i18next'
import { AdminOnlyBadge } from 'src/components/admin-only-badge.component'

type TResourceChangeHistoryButtonProps = {
  projectId: number
  patientId: number
  modelName?: string
  recordId?: string
}

export const ResourceChangeHistoryButton = ({
  projectId,
  patientId,
  modelName,
  recordId,
}: TResourceChangeHistoryButtonProps) => {
  const { currentUser } = useSession()
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (currentUser?.role !== 'admin') {
    return null
  }

  return (
    <>
      <div className="c-flex c-items-center c-gap-1">
        <button
          onClick={() => setIsModalOpen(true)}
          className="c-text-primary c-underline c-cursor-pointer c-bg-transparent c-p-0 c-pl-2 c-font-nexa hover:c-text-primary-500 c-flex c-items-center c-gap-1 c-border-l c-border-grey-500"
          type="button"
        >
          <AdminOnlyBadge />
          {t('pages.patient-page.resource-change-history.view-history')}
        </button>
      </div>
      <ResourceChangeHistoryModal
        projectId={projectId}
        patientId={patientId}
        modelName={modelName}
        recordId={recordId}
        isOpen={isModalOpen}
        onToggle={() => setIsModalOpen(false)}
      />
    </>
  )
}
